import { Component, OnInit } from '@angular/core';
import * as toastr from "toastr";
import * as moment from 'moment';
import { VisitasService } from '@modules/visitas/services/visitas.service';
import { Utilservice } from '@core/services/util.service';
import { faAirFreshener } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-controle-cliente-ativo-semana',
  templateUrl: './controle-cliente-ativo-semana.component.html',
  styleUrls: ['./controle-cliente-ativo-semana.component.css']
})
export class ControleClienteAtivoSemanaComponent implements OnInit {

  faAirFreshener = faAirFreshener;
  
  lsLiberacao = [];
  idsChecks: any[] = [];

  fzsInformado = "";

  isRequestingGrid: boolean = false;

  constructor(private visitService: VisitasService) { }

  ngOnInit() {

    this.consultar();

  }

  
  formatDate(date){
    return Utilservice.formatDate(date);
  }

  week = {
    start: moment().startOf('isoWeek'),
    end: moment().endOf('isoWeek'),
    formatedStart: moment().startOf('isoWeek').format('DD/MM/YYYY'),
    formatedEnd: moment().endOf('isoWeek').format('DD/MM/YYYY')
  };

  
  filters = {
    initialDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
    finalDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
    selectedSector: null,
    selectedVendedor: null,
    selectedStatusVisits: null,
    selectedFormaVisitaId: null,
    selectedFormaConsulta: null,
    selectedFormaVisita: null,
  }

  changeWeek(direction: string): void {
    const currentWeek = this.week;

    const date = direction == 'back' ?
      moment(currentWeek.start).subtract(7, 'd') : moment(currentWeek.end).add(1, 'd');

    this.week = {
      start: moment(date.startOf('isoWeek')),
      end: moment(date.endOf('isoWeek')),
      formatedStart: date.startOf('isoWeek').format('DD/MM/YYYY'),
      formatedEnd: date.endOf('isoWeek').format('DD/MM/YYYY')
    }

    this.filters.initialDate = date.startOf('isoWeek').format('YYYY-MM-DD');
    this.filters.finalDate = date.endOf('isoWeek').format('YYYY-MM-DD');
  }

  salvar(){

    if(this.fzsInformado == ""){
      toastr.error('Informe o FZS para fazer a liberação!');
      return;
    }

    const {
      initialDate,
      finalDate,
      selectedSector,
      selectedVendedor,
      selectedStatusVisits,
      selectedFormaVisitaId,
      selectedFormaConsulta
    } = this.filters;

    const params: any = {
      dataInicial: initialDate,
      dataFinal: finalDate,
      vendedorSetor: this.fzsInformado,
    }

    this.isRequestingGrid = true;

    this.visitService.LiebrarMenos8ClientesAtivos(params).subscribe(
      resp=> {
              toastr.success("Liberação concluída!");

              this.consultar();
            },
      error => {
              toastr.error(error)
            }
    )
    
    // this.consultar();
  }

  consultar(){

    const {
      initialDate,
      finalDate,
      selectedSector,
      selectedVendedor,
      selectedStatusVisits,
      selectedFormaVisitaId,
      selectedFormaConsulta
    } = this.filters;

    const form: any = {
      dataInicial: initialDate,
      dataFinal: finalDate,
      vendedorSetor: this.fzsInformado,
    }

    this.isRequestingGrid = true;

    this.visitService.listMenos8ClientesAtivos().subscribe(
      data => {
        this.lsLiberacao = data;
      },
      error => console.log(error),
      () => this.isRequestingGrid = false
    );
  }

  delete(){
    this.verificarCheckboxes();

    this.visitService.deleteLibMenos8ClientesAtivos(this.idsChecks).subscribe(
      data => {
        this.isRequestingGrid = false;
        toastr.success("Liberação excluida com sucesso");
        this.consultar();
      },
      error => {
        console.log(error);
        this.isRequestingGrid = false;

        if(typeof error === 'string'){
          toastr.error(error);
        }else{
          toastr.error("Falha ao excluir a visita");
        }

      },
      () => console.log("Get States")
    );
  }

  verificarCheckboxes() {
    for (let item of this.lsLiberacao) {
      if (item.selecionado) {
        this.idsChecks.push(item.idLib);
        // console.log('Checkbox marcado para o item:', item.nome);
      }
    }
  }

}
